import React from "react";

export default function VerifyInfo() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>Verify your email 📩</h1>
      <p>
        We've sent a verification link to your registered email address.<br/>
        Please click the link in that email to activate your account.
      </p>
    </div>
  );
}
